import { Share2 } from "lucide-react";
import { useRadio } from "@/context/RadioContext";
import { ShareMenu } from "@/components/site/ShareMenu";

const shareText = (title) => (title ? `J'écoute « ${title} » sur la radio LGTDZ` : "J'écoute la radio LGTDZ");

// Phones open the native share sheet in one tap; desktops get the networks menu.
export const ShareNowPlaying = ({ testId = "radio-share", label, className = "" }) => {
  const { nowPlaying } = useRadio();
  const text = shareText(nowPlaying);
  const url = `${window.location.origin}/radio`;
  const canNative = typeof navigator !== "undefined" && !!navigator.share && window.matchMedia("(pointer: coarse)").matches;

  if (canNative) {
    const share = () => navigator.share({ title: "Radio LGTDZ", text, url }).catch(() => {});
    return (
      <button type="button" onClick={share} aria-label="Partager le titre en cours" data-testid={`${testId}-trigger`}
        className={`inline-flex items-center justify-center gap-2 transition-colors duration-200 ${className}`}>
        <Share2 className="w-4 h-4" /> {label}
      </button>
    );
  }
  return <ShareMenu text={`${text} 🎧`} url={url} testId={testId} label={label} className={className} />;
};
